import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AIToolsHeader from "../components/AIToolsHeader";
import AIToolsDirectory from "../components/AIToolsDirectory";
import AIToolsInfo from "../components/AIToolsInfo";
import "../styles/home.css";

export default function Home() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedPricing, setSelectedPricing] = useState("All");
  const [sortBy, setSortBy] = useState("default");
  const [totalResults, setTotalResults] = useState(0);
  const navigate = useNavigate();

  const handleCountChange = useCallback((count) => setTotalResults(count), []);

  return (
    <div>
      <AIToolsHeader
        onSearch={setSearchQuery}
        onCategory={setSelectedCategory}
        onPricing={setSelectedPricing}
        onSort={setSortBy}
        totalResults={totalResults}
      />

      {/* ── Promo Banner ── */}
      <div
        style={{ margin: "28px 60px" }}
        className="howtos-promo-banner"
        onClick={() => navigate("/how-tos")}
      >
        <div className="promo-content">
          <span className="promo-tag">✨ New Resource</span>
          <div>
            <h3>Ace Your QA Interview! 🎯</h3>
            <p>Prepare with our comprehensive Question &amp; Answer guides for QA teams.</p>
          </div>
        </div>
        <button className="promo-btn">Explore How-To's →</button>
      </div>

      <AIToolsDirectory
        searchQuery={searchQuery}
        selectedCategory={selectedCategory}
        selectedPricing={selectedPricing}
        sortBy={sortBy}
        onCountChange={handleCountChange}
      />

      <AIToolsInfo />
    </div>
  );
}